import React, { FunctionComponent } from 'react';
import './PageListMini.scss';
import { useTranslation } from 'react-i18next';

export type PageListProps = {
  pages: Page[];
  limit?: number;
  totalCount: number;
};

// TODO Simplify the data for this with new api
type Page = {
  id: string;
  title: string;
  logo?: string | null;
  url: string;
};

const PageListMini: FunctionComponent<PageListProps> = props => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { pages, limit = 6, totalCount } = props;
  const actualLimit = limit || pages.length;
  return (
    <>
      <ul className="jg-pages-teams-pagelistmini">
        {pages.map((page, index) => {
          if (actualLimit <= index) {
            return null;
          }
          return (
            <li
              className="jg-pages-teams-pagelistmini-item"
              key={page.id}
              data-qa="page-list-item"
            >
              <a href={page.url} className="jg-pages-teams-pagelistmini-link">
                <img src={`${page.logo}?template=size120x120`} alt="" />
                <span className="jg-sr-only">{page.title}</span>
              </a>
            </li>
          );
        })}
      </ul>
      {actualLimit < totalCount && (
        <div className="jgp-TeamCTA__ctaWrapper">
          <a href="#aboutSection" className="jg-btn jg-btn--ghost">
            {t('common.showMore')}
            <span className="jg-sr-only"> {t('page.charitysMiniTitle')}</span>
          </a>
        </div>
      )}
    </>
  );
};

export default PageListMini;
